export const WorkflowConstants = {
  INITIATOR_TYPES: {
    UPLOAD_BROWSE_SCAN: 0,
    FORM: 1,
  },
};
